<template>
  <!--          行属性-->
  <a-descriptions
    class="form-group-block"
    bordered
    size="small"
    :column="2"
    v-if="group.inline.length > 0"
  >
    <a-descriptions-item
      :label="titleNode(item.title, item.desc)"
      v-for="item in group.inline"
      :key="item.id"
      :span="item.size === 'small' ? 1 : 2"
    >
      <component :is="item.component.value" v-bind="item.props" />
    </a-descriptions-item>
  </a-descriptions>
  <!--          块属性-->
  <a-tabs type="card" :tabBarGutter="8" style="overflow: visible" v-if="group.block.length > 0">
    <a-tab-pane
      :key="item.id"
      v-for="item in group.block"
      :tab="titleNode(item.title, item.desc)"
    >
      <div class="card-body">
        <component :is="item.component.value" v-bind="item.props" />
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script setup lang="ts">
import { FormContainerGroup } from '@/components/business/crud/widgets/FormWidgetContainer';
import { h } from 'vue';
import { Icon } from '@/components/common/Icon';
import { Tooltip } from 'ant-design-vue';

const props = defineProps<{
  group: FormContainerGroup;
}>();

function titleNode(title: string, desc?: string) {
  const slot = () => {
    return [
      title,
      desc
        ? h(
            Tooltip,
            {
              placement: 'topLeft',
              overlayStyle: { whiteSpace: 'pre-line' },
              title: desc,
            },
            {
              default: () =>
                h(Icon as any, {
                  type: 'QuestionCircleFilled',
                  style: {
                    padding: '4px 4px 4px 8px',
                    color: '#333',
                    marginRight: 'unset',
                  },
                }),
            }
          )
        : undefined,
    ];
  };

  return h('div', null, { default: slot });
}
</script>

<style lang="scss" scoped>
.form-group-block {
  padding-bottom: 20px;
}

.card-body {
  min-height: 100px;
}
</style>
